import { GetterTree } from "vuex";

import { CompanyState } from "../types";

const getters: GetterTree<CompanyState, any> = {
  getUBOs: (state) => state.ubos,
};

export default getters;
